// The full set of denominations a location can choose to have available when
// making a payout, and the default selection used when none is configured yet.
export const SELECTABLE_CURRENCIES: number[] = [50, 20, 10, 5, 2, 1, 0.5, 0.2, 0.1, 0.05];

export const DEFAULT_CURRENCIES: number[] = [...SELECTABLE_CURRENCIES];

export const DEFAULT_EXACT_CALCULATION: boolean = true;

export function sanitizeCurrencies(values: unknown): number[] {
    if (!Array.isArray(values)) return [...DEFAULT_CURRENCIES];

    const cleaned = Array.from(
        new Set(values.filter((v): v is number => typeof v === "number" && Number.isFinite(v) && v > 0))
    ).sort((a, b) => b - a);

    return cleaned.length > 0 ? cleaned : [...DEFAULT_CURRENCIES];
}
